import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Linkedin, Instagram, Twitter, Youtube } from "lucide-react";
import Logo from "./Logo";
import { SERVICE_ROUTES, LEGAL_LINKS, DISCLAIMER_SHORT } from "../../data/content";
import { useSettings } from "../../context/SettingsContext";

const COMPANY = [
  { to: "/about", label: "About Us" },
  { to: "/calculators", label: "Financial Calculators" },
  { to: "/blog", label: "Blog & Market Insights" },
  { to: "/contact", label: "Contact Us" },
  { to: "/book-consultation", label: "Book Consultation" },
  { to: "/login", label: "Client Portal" },
];

function Col({ title, links }) {
  return (
    <div>
      <h4 className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-gold">{title}</h4>
      <ul className="space-y-2.5">
        {links.map((l) => (
          <li key={l.to}><Link to={l.to} className="text-sm text-slate-400 transition-colors hover:text-white" data-testid={`footer-link-${l.to.slice(1) || "home"}`}>{l.label}</Link></li>
        ))}
      </ul>
    </div>
  );
}

function Socials({ s }) {
  const items = [[s?.linkedin_url, Linkedin, "LinkedIn"], [s?.instagram_url, Instagram, "Instagram"], [s?.twitter_url, Twitter, "X"], [s?.youtube_url, Youtube, "YouTube"]].filter(([u]) => u);
  if (!items.length) return null;
  return (
    <div className="mt-6 flex gap-3">
      {items.map(([u, Icon, n]) => (
        <a key={n} href={u} target="_blank" rel="noopener noreferrer" aria-label={n} data-testid={`footer-social-${n.toLowerCase()}`}
          className="flex h-9 w-9 items-center justify-center rounded-full border border-white/10 text-slate-300 transition-colors hover:border-gold hover:text-gold"><Icon size={16} /></a>
      ))}
    </div>
  );
}

export default function Footer() {
  const { settings: s } = useSettings();
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden bg-navy text-slate-300">
      <div className="container-q grid gap-12 py-16 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <Logo />
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-400">Your Future. Our Financial Intelligence.</p>
          <div className="mt-6 space-y-2 text-sm">
            <a href={`mailto:${s?.contact_email || ""}`} className="flex items-center gap-2 hover:text-white" data-testid="footer-email"><Mail size={15} className="text-mint" />{s?.contact_email}</a>
            <a href={`tel:${(s?.contact_phone || "").replace(/\s/g, "")}`} className="flex items-center gap-2 hover:text-white" data-testid="footer-phone"><Phone size={15} className="text-mint" />{s?.contact_phone}</a>
            <p className="flex items-center gap-2"><MapPin size={15} className="text-mint" />{s?.address}</p>
          </div>
          <Socials s={s} />
        </div>
        <Col title="Services" links={SERVICE_ROUTES.map((r) => ({ to: `/${r.slug}`, label: r.label }))} />
        <Col title="Company" links={COMPANY} />
        <Col title="Legal" links={LEGAL_LINKS} />
      </div>
      <div className="border-t border-white/10">
        <div className="container-q py-6 text-xs leading-relaxed text-slate-500">
          <p data-testid="footer-disclaimer">{DISCLAIMER_SHORT} Mutual fund investments are subject to market risks, read all scheme related documents carefully. Insurance is the subject matter of solicitation.</p>
          <p className="mt-3">© {new Date().getFullYear()} Quantora Analytics Private Limited. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
